module.exports = __webpack_public_path__ + "static/media/date-time.736d7a97.svg";